/** UI copy for Sidekick Download — Deutsch + English, aligned with Digital Personas */
export const SUPPORTED = [
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'en', label: 'English', flag: 'GB' },
];

export const strings = {
  de: {
    brand: 'Sidekick Download',
    brandDomain: 'sidekickdownload.com',
    nav: {
      home: 'Start',
      discover: 'Personas',
      features: 'Team',
      advantages: 'Vorteile',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    headerCta: 'Jetzt starten',
    hero: {
      badge: 'KI-Personas · Expertenberatung. Echte Gespräche.',
      titleA: 'Dein digitaler',
      titleB: 'Sidekick',
      titleC: 'Keine generische KI. Echte Vorbereitung für echte Situationen.',
      lead:
        'Eine KI-Persona-Plattform mit sofortigem Zugang zu spezialisierten Experten. Über natürliche, menschlich anmutende Gespräche. Rund um die Uhr, privat und erschwinglich.',
      ctaPrimary: 'Jetzt starten',
      ctaSecondary: 'Dein Team kennenlernen',
      legal:
        'Kostenpflichtiges wöchentliches Abonnement. Bezahlung über Mobile Billing (Mobilfunkrechnung). Mit Abschluss akzeptieren Sie unsere AGB. Kündigung jederzeit möglich. Support: help@niffomobile.com. Anbieter: Niffo Mobile B.V.',
      statTitle: 'Dein Beratungsteam',
      statSub: 'in der Hosentasche',
      priceChip: 'Wöchentliches Abo',
    },
    discover: {
      kicker: 'Das Problem',
      title: 'Momente, die du dir',
      titleGrad: 'nicht leisten kannst falsch zu machen',
      body:
        'Vorstellungsgespräche, wichtige Dates, Karriereentscheidungen, schwierige Gespräche, persönliche Krisen, soziale Situationen. Gute Beratung ist oft teuer, schwer erreichbar und Wochen im Voraus geplant. Also improvisieren Menschen. Das führt zu Angst, verpassten Chancen und Reue.',
      devicesTitle: 'Immer verfügbar',
      devicesSub: '24/7, privat, hyperpersonalisiert. Wie ein persönliches Beratungsgremium in der Tasche.',
    },
    features: {
      kicker: 'Dein persönliches KI-Team',
      items: [
        {
          title: 'Interview-Coach',
          description: 'Üben, bis Selbstvertrauen die Nervosität ersetzt. Vorstellungsgespräche, Pitches und Meetings in einer sicheren Umgebung.',
        },
        {
          title: 'Deine KI-Bestie',
          description: 'Rede über alles, ohne bewertet zu werden. Immer da, wenn du jemanden brauchst.',
        },
        {
          title: 'Wellness-Begleiter',
          description: 'Ein sicherer Raum zum Reflektieren und Stärken deiner mentalen Widerstandskraft.',
        },
        {
          title: 'Lebens-Stratege',
          description: 'Kontrolle zurückgewinnen, Komplexität meistern und die Zukunft gestalten, die du willst.',
        },
        {
          title: 'Sprachtutor',
          description: 'Natürlich sprechen, gemeinsam Aufgaben erledigen und die Logik hinter der Sprache verstehen.',
        },
        {
          title: 'KI-Koch',
          description: 'Smarter kochen mit den Zutaten, die du schon hast.',
        },
        {
          title: 'Innenarchitekt',
          description: 'Ein professionell gestyltes Zuhause, ohne den Profi-Preis.',
        },
        {
          title: 'Lifestyle-Coach',
          description: 'Dates, Pitches und unangenehme Momente üben. Lernen, was du sagst und was nicht.',
        },
      ],
    },
    how: {
      kicker: 'Vom Produkt zum Alltagsbegleiter',
      title: 'Digital Sidekick wird Teil',
      titleGrad: 'deines Tages',
      intro:
        'Morgens planen, nachmittags eine Sprache üben, abends kochen, vor einem Date proben. So wird aus einem Tool ein täglicher Begleiter.',
      blocks: [
        {
          title: 'Morgens',
          description: 'Plane deinen Tag mit deinem Strategen. Weniger reagieren, mehr gestalten.',
          points: ['Klarheit für den Tag', 'Prioritäten setzen', 'Kontrolle behalten'],
        },
        {
          title: 'Nachmittags',
          description: 'Übe eine Sprache mit deinem Tutor. Ohne Angst, bewertet zu werden.',
          points: ['Natürlich sprechen', 'Aufgaben gemeinsam lösen', 'Jederzeit verfügbar'],
        },
        {
          title: 'Abends',
          description: 'Koche mit deinem KI-Koch. Aus dem, was schon im Kühlschrank liegt.',
          points: ['Weniger Verschwendung', 'Smarte Rezepte', 'Alltagstauglich'],
        },
        {
          title: 'Vor einem Date',
          description: 'Probe mit deinem Lifestyle-Coach. Selbstvertrauen ist trainierbar.',
          points: ['Was sagen, was lassen', 'Unangenehme Momente lösen', 'Sicher üben'],
        },
      ],
    },
    advantages: {
      kicker: 'Warum das wirkt',
      title: 'Andere geben Antworten.',
      titleGrad: 'Wir bauen bessere Menschen.',
      intro:
        'Digital Sidekick ist eine Plattform für persönliche Veränderung. Personas, emotionale Intelligenz, Szenario-Training und Alltagstauglichkeit.',
      quote: 'Das Leben ist zu wichtig, um zu improvisieren.',
      quoteSub:
        'Übe es. Lerne es. Sprich es durch. Koche es. Date mit Selbstvertrauen. Jeder verdient einen Sidekick.',
      bullets: [
        'Selbstvertrauen auf Abruf: Vorbereitung nimmt Angst.',
        'Immer da: kein Termin, keine Reibung.',
        'Kontrolle über dein Leben: aufhören zu reagieren, anfangen zu gestalten.',
        'Expertenhilfe ohne Expertenpreise.',
        'Ein privater Raum zum Üben: sicher scheitern, schneller lernen.',
      ],
      cta: 'Jetzt starten',
      panelTitle: 'Persönliche KI-Begleiter',
      panelKicker: 'DIGITAL PERSONAS',
      panelBody: 'Nicht generische KI. Keine passiven Tools. Echte Vorbereitung für echte Situationen.',
      panelSub: 'Wir definieren die Kategorie der persönlichen KI-Begleiter.',
      imageAlt: 'Gespräch mit einem digitalen Sidekick',
      panelAlt: 'Digitale Personas',
    },
    cta: {
      badge: 'Bereit für deinen Sidekick?',
      title: 'Practice it. Learn it.',
      titleSub: 'Talk it through.',
      body: 'Schalte dein persönliches KI-Team frei. Coach, Stratege, Tutor, Koch, Designer, Wellness-Guide und Begleiter. In der Hosentasche.',
      perks: [
        'Unbegrenzter Zugang',
        'Spezialisierte Personas',
        'Jederzeit kündbar',
        'Privat by design',
      ],
      button: 'Jetzt starten',
      priceLine: 'Wöchentliches Abonnement. Bezahlung über Mobile Billing.',
      helpLine: 'Support: help@niffomobile.com',
      legalBox:
        'Sidekick Download ist ein kostenpflichtiger KI-Service. Mit Abschluss des Abonnements akzeptieren Sie unsere AGB. Das Abonnement verlängert sich automatisch, sofern es nicht gekündigt wird. Bezahlung über Mobile Billing (Mobilfunkrechnung). Anbieter: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Niederlande.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Häufige',
      titleGrad: 'Fragen',
      intro: 'Antworten auf die wichtigsten Fragen zu Sidekick Download.',
      items: [
        {
          q: 'Was ist Sidekick Download?',
          a: 'Sidekick Download ist dein Zugang zu Digital Sidekick: einer KI-Persona-Plattform mit spezialisierten Experten für echte Gespräche. Interview-Coach, Bestie, Wellness-Begleiter, Lebens-Stratege, Sprachtutor, KI-Koch, Innenarchitekt und Lifestyle-Coach.',
        },
        {
          q: 'Ist das einfach eine generische KI?',
          a: 'Nein. Jede Persona ist auf ein konkretes Lebensfeld trainiert: Gespräche üben, Entscheidungen treffen, Sprachen lernen, kochen, wohnen, Beziehungen. Nicht nur Antworten, sondern Vorbereitung.',
        },
        {
          q: 'Was kostet Sidekick Download?',
          a: 'Sidekick Download ist ein kostenpflichtiger Service als wöchentliches Abonnement. Die Bezahlung erfolgt über Mobile Billing (Mobilfunkrechnung).',
        },
        {
          q: 'Kann ich mein Abo kündigen?',
          a: 'Ja, du kannst dein Abonnement jederzeit kündigen. Die Kündigung wird zum Ende der laufenden Abrechnungsperiode wirksam.',
        },
        {
          q: 'Welche Geräte werden unterstützt?',
          a: 'Sidekick Download funktioniert auf aktuellen Browsern (Chrome, Safari, Firefox, Edge) sowie auf Smartphones und Tablets.',
        },
      ],
      contactTitle: 'Noch Fragen?',
      contactLead: 'Schreib uns. Wir helfen gerne weiter.',
      email: 'help@niffomobile.com',
    },
    footer: {
      navTitle: 'Rechtliches',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Niederlande',
      copyright: 'Sidekick Download',
      agb: 'AGB',
      privacy: 'Datenschutzerklärung',
      help: 'Hilfe',
      imprint: 'Impressum',
      widerruf: 'Widerrufsbelehrung',
    },
  },
  en: {
    brand: 'Sidekick Download',
    brandDomain: 'sidekickdownload.com',
    nav: {
      home: 'Home',
      discover: 'Personas',
      features: 'Team',
      advantages: 'Benefits',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Get started',
    hero: {
      badge: 'AI personas · Expert guidance. Real conversations.',
      titleA: 'Meet your digital',
      titleB: 'Sidekick',
      titleC: 'Not generic AI. Real preparation for real life.',
      lead:
        'An AI persona platform that gives you instant access to specialised experts through natural, human-like conversations. Available 24/7, private by design, and radically affordable.',
      ctaPrimary: 'Get started',
      ctaSecondary: 'Meet your team',
      legal:
        'Paid weekly subscription. Payment via mobile billing. By subscribing you accept our terms. Cancel anytime. Support: help@niffomobile.com. Provider: Niffo Mobile B.V.',
      statTitle: 'Your advisory board',
      statSub: 'in your pocket',
      priceChip: 'Weekly subscription',
    },
    discover: {
      kicker: 'The problem',
      title: 'Moments you cannot',
      titleGrad: 'afford to get wrong',
      body:
        'Job interviews, important dates, career decisions, difficult conversations, personal struggles, social situations. Guidance is often expensive, hard to access, and scheduled weeks ahead. So people improvise. That leads to anxiety, missed opportunities, and regret.',
      devicesTitle: 'Always available',
      devicesSub: '24/7, private, hyperpersonalised. Like a personal advisory board in your pocket.',
    },
    features: {
      kicker: 'Your personal AI team',
      items: [
        {
          title: 'Interview Coach',
          description: 'Practice until confidence replaces nerves. Interviews, pitches, and meetings in a completely safe space.',
        },
        {
          title: 'Your AI Bestie',
          description: 'Talk about anything with zero judgment. Always there when you need it.',
        },
        {
          title: 'Wellness Companion',
          description: 'A safe space to reflect and strengthen mental resilience.',
        },
        {
          title: 'Life Strategist',
          description: 'Regain control, navigate complexity, and design the future you want.',
        },
        {
          title: 'Language Tutor',
          description: 'Speak naturally, complete assignments together, and understand the logic behind the language.',
        },
        {
          title: 'AI Chef',
          description: 'Cook smarter using the ingredients you already have.',
        },
        {
          title: 'Interior Designer',
          description: 'A professionally styled home without the professional price.',
        },
        {
          title: 'Lifestyle Coach',
          description: 'Rehearse dates, pitches, and awkward moments. Learn what to say, and what not to say.',
        },
      ],
    },
    how: {
      kicker: 'From product to daily companion',
      title: 'Digital Sidekick becomes part of',
      titleGrad: 'how you live',
      intro:
        'Plan the morning with your strategist, practise a language in the afternoon, cook in the evening, rehearse before a date.',
      blocks: [
        {
          title: 'Morning',
          description: 'Plan your day with your strategist. Stop reacting and start designing.',
          points: ['Clarity for the day', 'Set priorities', 'Stay in control'],
        },
        {
          title: 'Afternoon',
          description: 'Practise a language with your tutor. No fear of being judged.',
          points: ['Speak naturally', 'Solve tasks together', 'Available anytime'],
        },
        {
          title: 'Evening',
          description: 'Cook with your AI chef, using what is already in the fridge.',
          points: ['Less waste', 'Smarter recipes', 'Built for real life'],
        },
        {
          title: 'Before a date',
          description: 'Rehearse with your Lifestyle Coach. Confidence is trainable.',
          points: ['What to say, what not to', 'Handle awkward moments', 'Practise safely'],
        },
      ],
    },
    advantages: {
      kicker: 'Why this wins',
      title: 'Others provide answers.',
      titleGrad: 'We build better humans.',
      intro:
        'Digital Sidekick is a personal transformation platform. Persona-driven experiences, emotional intelligence, scenario-based practice, and extremely high life relevance.',
      quote: 'Life is too important to improvise.',
      quoteSub:
        'Practice it. Learn it. Talk it through. Cook it. Date with confidence. Everyone deserves a sidekick.',
      bullets: [
        'Confidence on demand: preparation removes fear.',
        'Always available: no scheduling, no friction.',
        'Take control of your life: stop reacting and start designing.',
        'Expert help without expert prices.',
        'A private space to improve: fail safely and learn faster.',
      ],
      cta: 'Get started',
      panelTitle: 'Personal AI companions',
      panelKicker: 'DIGITAL PERSONAS',
      panelBody: 'Not generic AI. Not passive tools. Real preparation for real life.',
      panelSub: 'We are defining the category of Personal AI Companions.',
      imageAlt: 'Conversation with a digital sidekick',
      panelAlt: 'Digital personas',
    },
    cta: {
      badge: 'Ready for your sidekick?',
      title: 'Practice it. Learn it.',
      titleSub: 'Talk it through.',
      body: 'Unlock your personal AI team. Coach, strategist, tutor, chef, designer, wellness guide, and companion. In your pocket.',
      perks: [
        'Unlimited access',
        'Specialised personas',
        'Cancel anytime',
        'Private by design',
      ],
      button: 'Get started',
      priceLine: 'Weekly subscription. Payment via mobile billing.',
      helpLine: 'Support: help@niffomobile.com',
      legalBox:
        'Sidekick Download is a paid AI service. By subscribing you accept our terms. The subscription renews automatically unless cancelled. Payment via mobile billing. Provider: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Netherlands.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Common',
      titleGrad: 'questions',
      intro: 'Answers to the most important questions about Sidekick Download.',
      items: [
        {
          q: 'What is Sidekick Download?',
          a: 'Sidekick Download is your access to Digital Sidekick: an AI persona platform with specialised experts for real conversations. Interview Coach, Bestie, Wellness Companion, Life Strategist, Language Tutor, AI Chef, Interior Designer, and Lifestyle Coach.',
        },
        {
          q: 'Is this just generic AI?',
          a: 'No. Each persona is trained for a concrete part of life: practising conversations, making decisions, learning languages, cooking, styling, relationships. Not just answers, but preparation.',
        },
        {
          q: 'What does Sidekick Download cost?',
          a: 'Sidekick Download is a paid service offered as a weekly subscription. Payment is via mobile billing.',
        },
        {
          q: 'Can I cancel my subscription?',
          a: 'Yes, you can cancel anytime. Cancellation takes effect at the end of the current billing period.',
        },
        {
          q: 'Which devices are supported?',
          a: 'Sidekick Download works on current browsers (Chrome, Safari, Firefox, Edge) as well as smartphones and tablets.',
        },
      ],
      contactTitle: 'Still have questions?',
      contactLead: 'Write to us. We are happy to help.',
      email: 'help@niffomobile.com',
    },
    footer: {
      navTitle: 'Legal',
      company: 'Niffo Mobile B.V.',
      address: 'Stationsplein 28, 1382 AD Weesp, Netherlands',
      copyright: 'Sidekick Download',
      agb: 'Terms',
      privacy: 'Privacy Policy',
      help: 'Help',
      imprint: 'Legal Notice',
      widerruf: 'Cancellation Policy',
    },
  },
};
